import React from 'react';
import { Modal } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import { BlueButton } from '@share/components';

import type { CertificateTermsModalProps } from './types';
import { TERMS_SECTION_CONFIG } from './constants';

import styles from './styles.module.scss';
import { HtmlMarkdownContent } from '@components';

export function CertificateTermsModal({
  termsAndConditionsContent,
  open,
  onClose,
}: CertificateTermsModalProps): React.ReactElement {
  const intl = useIntl();

  return (
    <Modal
      className={styles.modal}
      visible={open}
      title={intl.formatMessage({ id: 'certificates.terms.modalTitle' })}
      onCancel={onClose}
      footer={
        <div className={styles.footer}>
          <BlueButton className={styles.closeButton} onClick={onClose}>
            <FormattedMessage id="certificates.terms.close" />
          </BlueButton>
        </div>
      }
      closable
      centered
      width={560}
    >
      <div className={styles.content}>
        {termsAndConditionsContent ? (
          <HtmlMarkdownContent content={termsAndConditionsContent} />
        ) : (
          TERMS_SECTION_CONFIG.map((section) => (
            <section key={section.titleId} className={styles.section}>
              <h3 className={styles.sectionTitle}>
                <FormattedMessage id={section.titleId} />
              </h3>
              {'listIds' in section ? (
                <ul className={styles.sectionList}>
                  {section.listIds.map((id) => (
                    <li key={id}>
                      <FormattedMessage id={id} />
                    </li>
                  ))}
                </ul>
              ) : (
                <p className={styles.sectionParagraph}>
                  <FormattedMessage id={section.paragraphId} />
                </p>
              )}
            </section>
          ))
        )}
      </div>
    </Modal>
  );
}
